// import "jquery";
import "jquery-form";
import RailsUJS from "rails-ujs";
import Salert from "react-s-alert";
import switchFn from "../../application/components/switchFn";

import "./style.scss";

RailsUJS.start();

setTimeout(() => {
  // gloal ajax error
  $.ajaxSetup({
    headers: {
      "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
    },
    error: xhr => {
      if (xhr.responseJSON instanceof Array) {
        return;
      }
      Salert.error(xhr.responseText);
    },
  });

  switchFn();
});